// The follow-up chip on a rejected or denied ledger row.
//
// One extra fetch per ledger page, not per row: the ledger already knows which
// claims it is showing, so `useClaimFollowups` asks the worklist endpoint once and
// the chip reads the answer out of the map. A chip that fetched per row would be
// fifty round trips on a full page, which is the mistake the claim-comment summary
// was bulked to avoid.

import React from "react";
import "./PostingModals.css";

const API_URL = process.env.REACT_APP_API_URL || "";

const LABEL = {
  open: "follow-up",
  working: "working",
  resolved: "resolved",
  wontfix: "won't fix",
};

export default function FollowupChip({ followup, overdue }) {
  if (!followup) return null;
  const status = followup.status || "open";
  const classes = ["followup-chip", status];
  if (overdue) classes.push("overdue");
  const owner = followup.owner ? ` · ${followup.owner}` : "";
  return (
    <span
      className={classes.join(" ")}
      title={
        followup.next_action
          ? `${followup.next_action}${followup.due_on ? ` (due ${followup.due_on})` : ""}`
          : "On the denial worklist"
      }
    >
      {LABEL[status] || status}
      {owner}
    </span>
  );
}

// Fetch every open follow-up for a practice once, as {claimId: {followup, overdue}}.
// Returns an empty map when the worklist feature is off — the endpoint 404s and the
// chips simply do not appear, which is the correct degradation.
export async function fetchFollowupMap(practiceId) {
  if (!practiceId) return {};
  try {
    const resp = await fetch(
      `${API_URL}/api/practices/${practiceId}/claims/worklist?status=all&limit=2000`,
      { credentials: "include" },
    );
    if (!resp.ok) return {};
    const body = await resp.json();
    const map = {};
    (body.worklist || []).forEach((row) => {
      map[row.claim.id] = { followup: row.followup, overdue: row.overdue };
    });
    return map;
  } catch (err) {
    // A chip is decoration on a page that must still render. Never surface this.
    return {};
  }
}
